class SizeGuideConversion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.commaDecimal = false
    this.currentUnit = 'cm'
    this.setUnit(this.currentUnit)
  }

  setupListeners () {
    super.setupListeners()

    this.els.button?.elements.forEach((buttonEl) => {
      this.listeners.add(buttonEl, 'click', this.onButtonClick.bind(this))
    })
  }

  onButtonClick (event) {
    const buttonEl = event.currentTarget
    const unit = buttonEl.dataset.sizeGuideConversionUnit

    if (!unit) return

    this.setUnit(unit)
  }

  setUnit (unit) {
    this.currentUnit = unit

    this.els.button?.elements.forEach((buttonEl) => {
      const isActive = buttonEl.dataset.sizeGuideConversionUnit === unit

      buttonEl.setAttribute('aria-pressed', isActive ? 'true' : 'false')
    })

    this.els.convertibleValue?.elements.forEach((valueEl) => {
      const cmValue = valueEl.dataset.sizeGuideConversionCmValue

      if (cmValue.includes(',')) {
        this.commaDecimal = true
      }

      if (!cmValue) return

      valueEl.textContent =
        unit === 'cm'
          ? cmValue
          : this.convertCmValueToInches(cmValue.replaceAll(',', '.'))
    })

    this.els.unitLabel?.elements.forEach((labelEl) => {
      labelEl.textContent =
        unit === 'cm'
          ? labelEl.dataset.sizeGuideConversionCmLabel
          : labelEl.dataset.sizeGuideConversionInLabel
    })
  }

  convertCmValueToInches (value) {
    const string = String(value).trim()

    if (!this.isConvertibleValue(string)) return value

    return string
      .split(/\s*-\s*/)
      .map((part) => this.convertSingleCmValueToInches(part))
      .join(' - ')
  }

  convertSingleCmValueToInches (value) {
    const number = parseFloat(value)

    if (Number.isNaN(number)) return value

    const valueString = Number((number / 2.54).toFixed(1)).toString()

    return this.commaDecimal ? valueString.replace('.', ',') : valueString
  }

  isConvertibleValue (value) {
    return /^(\d+(\.\d+)?)(\s*-\s*\d+(\.\d+)?)?$/.test(String(value).trim())
  }
}

if (!customElements.get('size-guide-conversion')) {
  customElements.define('size-guide-conversion', SizeGuideConversion)
}
